import React from 'react';
import AnnouncementIcon from '@material-ui/icons/Announcement';
import config from './config';
import Push from './pages/Push';
import NewPush from './pages/Push/New';
import Layout from '../../components/Layout';

const path = config.PATH;
const name = config.NAME;

const routes = [
  {
    name,
    path,
    component: Layout,
    icon: <AnnouncementIcon />,
    routes: [
      {
        name: 'Push', path: `${path}/push`, component: Push, exact: true,
      },
      {
        name: 'Agregar push', path: `${path}/push/nuevo`, component: NewPush, exact: true,
      },
    ],
  },
];

export default routes;
